export const T = {
  en_GB: {
    portfolioSelectionRequired: "Please complete the portfolio selection to see forecast data.",
    forecastDataNotAvailable:
      "Forecast data is not available for this portfolio. This may be because the forecast API is not running. Please contact your advisor.",
    snapshotMissingMessage:
      "Forecast data needs to be regenerated. Use the Regenerate button above.",
    errorLoadingForecast: "Error loading forecast data. Please refresh the page.",
    forecastUnavailable: "Portfolio Forecast Unavailable",
  },
  nb_NO: {
    portfolioSelectionRequired: "Fullfør porteføljevalget for å se prognosedata.",
    forecastDataNotAvailable:
      "Prognosedata er ikke tilgjengelig for denne porteføljen. Dette kan skyldes at prognose-API-et ikke kjører. Kontakt din rådgiver.",
    snapshotMissingMessage: "Prognosedata må regenereres. Bruk Regenerer-knappen over.",
    errorLoadingForecast: "Feil ved lasting av prognosedata. Oppdater siden.",
    forecastUnavailable: "Porteføljeprognose ikke tilgjengelig",
  },
} as const;
